module.exports = __webpack_public_path__ + "static/media/pg_dnm_ph.21939581.jpg";